<template>
  <ContentPage>
    <template #header>
      <div class="pl-2" style="font-size: 20px; font-weight: bold">
        Your Requests
      </div>
    </template>
    <LeadList @drill-down="clickCustomer" />
  </ContentPage>
</template>

<script>
  import { ContentPage } from '@/components/pages'
  import LeadList from './LeadList'

  export default {
    name: 'LeadsView',

    components: {
      ContentPage,
      LeadList,
    },

    methods: {
      clickCustomer(cust) { 
        this.$router.push({ name: 'leads/show', params: { id: cust.customer_request_id } })
      }
    },
  }
</script>